import { v4 as uuid } from 'uuid';
import { showModal, hideModal } from '+/modal/redux';
import history from '#/history';
// This is the function that will be called in
// order to pass redux actions into React component.
// eslint-disable-next-line no-unused-vars
let interceptor;

export const setInterceptor = fn => {

    interceptor = fn;
};

export const flashAction = payload => {

    payload.id = uuid();
    payload.time = +new Date();

    return {
        type: 'flash',
        payload
    };
};

const typesToIntercept = [
    'FLASH',
    'ALERT',
    'alert'
];

export const flashMiddleware = ({ dispatch }) => next => action => {

    if (typesToIntercept.includes(action.type)) {

        dispatch(flashAction(action.payload));
    }

    if (/403/.test(action.type)) {
        dispatch(
            showModal({
                title: 'Access Denied',
                text: 'You do not have the proper permissions to access this page',
                icon: 'error',
                onClose: () => {
                    dispatch(hideModal());
                    history.goBack();
                }
            })
        );
    }

    // if (/422/.test(action.type)) {

    //     dispatch(
    //         showModal({
    //             title: 'Error inserting new Unit Type',
    //             text: 'The unit type name already exists; please use a different name',
    //             icon: 'error',
    //             onClose: () => {
    //                 dispatch(hideModal());
    //                 history.goBack();
    //             }
    //         })
    //     );
    // }


    if (/Fail/.test(action.type)) {

        // Handle if it is Axios response
        const { response } = action.payload;

        if (response) {

            response.data.type = 'error';
            dispatch(flashAction(response.data));
        }
        else {

            action.payload.type = 'error';
            dispatch(flashAction(action.payload));
        }
    }


    if (action.type === 'success') {

        action.payload.type = 'success';
        dispatch(flashAction(action.payload));
    }

    if (action.type === 'flash') {

        interceptor && interceptor(action.payload);
    }

    next(action);
};

export default flashMiddleware;
